var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeNetcdfGridded = {
    add_data_variable: function (data_in) {
        var grid_prop = this.get_grid_properties();
        if (
                data_in && data_in['grid-properties'] && data_in['grid-properties'].origin && data_in['grid-properties'].delta &&
                OCS.Utilities.is_array_equal(data_in['grid-properties'].origin, grid_prop.origin) &&
                OCS.Utilities.is_array_equal(data_in['grid-properties'].delta, grid_prop.delta) && data_in.variables)
        {
            Object.append(this.data().variables, data_in.variables);
            return true;
        }
        return false;
    },
    get_data_variable: function (data_var, data_unit) {
        if (!data_var) {
            return false;
        }
        var out = false;
        if (OCS.Utilities.is_string(data_var)) {
            data_var = {'parm': data_var};
            if (data_unit) {
                data_var.units = data_unit;
            }
        }
        var data = this.data();
        var vars = this.get_variables();
        if (vars.contains(data_var.parm)) {
            if (data_var.units && data.variables[data_var.parm].units !== data_var.units) {
                // So we have the data, but its in the wrong units
                if (!vars.contains(data_var.parm + "|" + data_unit)) {
                    return false;
                } else {
                    data_var.parm += "|" + data_unit;
                }
            }
            out = {'grid-properties': data['grid-properties'], 'variables': Object.subset(data.variables, [data_var.parm])};
        }
        return out;
    },
    get_variables: function () {
        return Object.keys(this.data().variables);
    },
    /**
     * Returns the units of the variable
     * @param {type} variable
     * @returns String
     */
    get_variable_units: function (variable) {
        var data = this.get_data_variable(variable);
        return data.variables[variable].units;
    },
    get_grid_properties: function () {
        return this.data()['grid-properties'];
    },
    is_gridded: function () {
        return true;
    },
    is_valid: function (data_var, data_unit) {
        if (!data_var) {
            data_var = this.get_variables()[0];
            data_unit = this.get_variable_units(data_var);
        }
        var data_obj = this.get_data_variable(data_var, data_unit);
        var data = data_obj.variables[data_var].data;
        
        // Loop through all the rows, if we find data that is not null, its valid
        for (var i = 0; i < data.length; i++) {
            if (!OCS.Utilities.array_equal_check(data[i]) || !OCS.Utilities.array_null_check(data[i])) {
                // Data is all null, not valid
                return true;
            }
        }
        // Data contained all nulls, return false
        return false;
    }
};